export const PAYMENT_LINK_ACTION_IDS = {
  SETTINGS: 1,
  EDIT_CHECKOUT: 2,
  EDIT_THANK_YOU: 3,
  SHOW_QR: 4,
  EXPIRE: 5,
  DUPLICATE: 6,
};
